var React = require('react');

function Billing (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"4","width":"22","height":"16","rx":"2","ry":"2","key":0}),React.createElement("line",{"x1":"1","y1":"10","x2":"23","y2":"10","key":1})]);
}

Billing.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-credit-card"};

module.exports = Billing;

Billing.default = Billing;
